import {produce} from "immer";

const INITIAL_REDUCER_STATE = {
    projects: [],
    users: [],
    projectsFormular: null,
    musicianFormular: null,
    showTable: true,
    detailFormProps: {},
    copySuccess: null,
    // inputData: {},  // {proj_id-user_id-instr: {status: "", isSaved: false, is_filled_form: true}} - tylko do interakcji z inputami=change
}

// const users_initial = (usersData) => {
//     const new_users_obj = usersData.map((instr, user_dict) => {
//         const users = user_dict.map(user => {
//             const user_obj = {}
//             Object.entries(user.participation).forEach(([proj, status_data]) => {
//                 user_obj[proj] = {status: status_data, is_filled_status: false}
//
//             });
//         })
//
//         return new_users_obj
//     })
// }


const participationReducer = (state, action) => {
    switch (action.type) {
        case "INITIAL_DATA":
            return {
                ...state,
                projects: action.projects,
                users: action.users,
            };

        case "SET_COPY_SUCCESS":
            return {
                ...state,
                copySuccess: action.copySuccess,
            };

        case 'SET_SHOW_TABLE':
            return { ...state, showTable: action.showTable };

        case 'SET_USERS':
            return { ...state, users: action.users };

        case 'SET_DETAIL_FORM_PROPS':   // dane wejsciowe do formularza szczegolow (lupa)
            return { ...state, detailFormProps: action.detailFormProps };

        case "SET_INPUT_VALUE":
            return produce(state, draft => {
                const { instrumentName, userId, projectId, newValue , is_filled_form} = action.payload;

                if (!is_filled_form) { // zmien na "--" pozostale inputy
                    // dla kazdego instrumentu zmien status na "--"
                    draft.users.forEach(([instrName, users]) => {
                        users.forEach(user => {
                            if (user.user_id === userId) {
                                if (projectId in  user.participation) {
                                    user.participation[projectId] = {
                                        status: instrName === instrumentName ? newValue : "--",
                                        is_filled_form: is_filled_form
                                    }
                                } else {
                                    user.participation = {projectId: {}}
                                    user.participation[projectId] = {
                                        status: instrName === instrumentName ? newValue : "--",
                                        is_filled_form: is_filled_form
                                    }
                                    // draft.inputData[`${projectId}-${userId}-${instrumentName}`] = {status: newValue}
                                }
                            }
                        });
                    });
                }
            });
        default:
            throw new Error('Unknown action: ' + action);
    }
}

export {participationReducer, INITIAL_REDUCER_STATE}

